import React, {useState} from 'react';

import { toast } from 'react-toastify' //npm i react-toastify
import getDataFromApi, { sendtoAdmin } from '../../api/getDataFromApi'
import loader from './../../../img/preLoader.gif'
import validator from "validator";
import { Form, FloatingLabel } from 'react-bootstrap';

import SystemUsersShow from './SystemUsersShow'

export default function SystemUsersManagement() {

    const [responseUsers, setResponseUsers] = useState(false);
    const [loading, setLoading] = useState(false)

    const [formData, setFormData] = useState(defaultValueForm())
    const [showErrors, setshowErrors] = useState(false);

    if(!loading && !responseUsers) {

        sendtoAdmin('getUsers','users', {} ,setResponseUsers,setLoading);

    }

    const onChange = (e) => {

        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        })

    }

    const doSubmit = () => {

        setshowErrors(true);

        if (!formFlagError) {

            const send = formData;
            //console.log('send :>> ', send);

            if (!loading) {

                makeUserAPI('createUser', 'users', send, setLoading, setFormData, setResponseUsers, setshowErrors)

            }

        }

    }

    let formFlagError = (
        !formData.name || 
        !formData.username  || !validator.isAlphanumeric(formData.username) || !validator.isLength(formData.username, 4) ||
        (!formData.password || !validator.isLength(formData.password, 4)    || !validator.isAlphanumeric(formData.password) ) ||
        (!formData.userType)
        
        );


  return <div className='SystemUsersManagement accordeonContent'>
      
      <h2>הוספת משתמש חדש למערכת</h2>
      <img src={loader} alt="loader" className={!loading ? 'loader' : 'loader active animate__animated animate__fadeIn'} />


        <div className='inputs'>
            <div className='input'>
                <FloatingLabel label="שם מלא" >

                    <Form.Control
                        className="customFloatInput"
                        placeholder='שם מלא'
                        isInvalid={showErrors && (!formData.name)}
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={onChange}
                    />
                </FloatingLabel>

            </div>

            <div className='input'>
                <FloatingLabel label="שם משתמש באנגלית" >

                    <Form.Control
                        className="customFloatInput"
                        placeholder='שם משתמש באנגלית'
                        isInvalid={showErrors && (!formData.username || !validator.isAlphanumeric(formData.username) || !validator.isLength(formData.username, 4)) }
                        type="text"
                        name="username"
                        value={formData.username}
                        onChange={onChange}
                    />
                </FloatingLabel>
            </div>

            <div className='input'>
                <FloatingLabel label="סיסמה" >

                    <Form.Control
                        className="customFloatInput"
                        placeholder='סיסמה'
                        isInvalid={showErrors && (!formData.password || !validator.isLength(formData.password, 4)    || !validator.isAlphanumeric(formData.password) ) }
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={onChange}
                    />
                </FloatingLabel>
            </div>

            <div className='input'>
                <FloatingLabel label="טלפון נייד" >

                    <Form.Control
                        className="customFloatInput"
                        placeholder='טלפון נייד'
                        type="text"
                        name="phone"
                        value={formData.phone}
                        onChange={onChange}
                    />
                </FloatingLabel>

            </div>

            <div className='input'>
                <FloatingLabel label="סוג משתמש" >

                    <Form.Control
                        as="select"
                        className="customSelectInput customFloatInput"
                        placeholder='סוג משתמש'
                        isInvalid={showErrors && (!formData.userType ) }
                        name="userType"
                        value={formData.userType}
                        onChange={onChange}
                    >
                        <option value="">בחירת סוג משתמש</option>
                        <option value="1">מנהל מערכת</option>
                        <option value="2">מנהל</option>
                        <option value="3">משתמש רגיל</option>
                        <option value="4">רק צפייה</option>
                    </Form.Control>

                </FloatingLabel>
            </div>

            <div className='input' style={{paddingTop: '7px'}}>
                <div className='btnCont'>
                    <button type="button" disabled={loading} className={`defaultBtnPic ${formFlagError ? 'disabled' : 'animate__animated animate__bounceIn'}`} onClick={doSubmit} >
                        <span>יצירת משתמש חדש</span>
                    </button>
                </div>
            </div>

        </div>

        {responseUsers.users && <SystemUsersShow users = {responseUsers.users} setResponseUsers = {setResponseUsers} /> }


  </div>
}

function defaultValueForm() {

    return {

        name: '',
        username: '',
        password: '',
        userType: '',
        phone: ''
    }

}

function makeUserAPI(url, controller, objectToSend, setLoading, setFormData, setResponseUsers, setshowErrors) {
    setLoading(true)
    const getData = getDataFromApi(url, objectToSend, controller, 'all')

    getData.then((getData) => {

        //console.log(getData);

        if (getData.ok) {
            
            toast.success(getData.ok);
            setFormData(defaultValueForm());
            setshowErrors(false);
            setResponseUsers(false);

        } else if (getData.error) {
            toast.error(getData.error)
        }
    })

    getData.catch((error) => {
        console.log(error)
    })

    getData.finally(() => {
        setLoading(false)
    })
} 